import EventSettingPage from "../components/page/EventSettingPage";

const EventEdit = () => {
  return (
      <EventSettingPage />
  );
};
export default EventEdit;
